// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__17pcK","modalFooterButton":"ModalNotes_modalFooterButton__2FF4X"};